import { styled } from '@attentive-platform/stem-ui';

export const PaginationRow = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '16px 24px'
});

export const CompaniesLabel = styled('label')({
  display: 'block',
  marginBottom: 8,
  fontSize: 14,
  fontWeight: 500,
  color: '#1f2937',
  textAlign: 'left'
});
